<template>
    <div>
        <b-table
            id="cdas"
            :items="resultado"
            :fields="fields"
            striped
            small
            responsive="sm"
            :no-local-sorting="true"
            @sort-changed="sortingChanged"
            :busy="configTable.load"
            show-empty
            >
            <div slot="table-busy" class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
            </div>
            <template slot="empty">
                <p class="my-auto">Nenhuma dívida enviada para protesto encontrada.</p>
            </template>

            <template slot="1" slot-scope="row">
                <b-link @click="abrirModalExtratoCda(row.item.codCdaSefa)" class="m-0 p-0 text-center">
                    <p class="m-0 p-0"> {{ row.item.numeroDivida }} </p>
                </b-link>
            </template>
            <template slot="2" slot-scope="row">
                <template v-for="c in row.item.devedores">
                    {{ c.nome }}
                    <br :key="c.codDevedor" />
                </template>
            </template>
            <template slot="3" slot-scope="row">
                 <template v-for="c in row.item.devedores">
                    {{ c.cpfCnpj | cpfCnpj }}
                    <br :key="c.codDevedor" />
                </template>
            </template>
            <template slot="4" slot-scope="row">
                {{ row.item.tipoCredito }}
            </template>
            <template slot="5" slot-scope="row">
                {{ row.item.origem }}
            </template>
            <template slot="6" slot-scope="row">
                {{ row.item.cadicms }}
            </template>
            <template slot="7" slot-scope="row">
                {{ row.item.dtInscricao }}
            </template>
            <template slot="8" slot-scope="row">
                {{ row.item.valorTotal | currency }}
            </template>
            <template slot="9" slot-scope="row">
                {{ row.item.comarca }}
            </template>
            <template slot="10" slot-scope="row">
                {{ row.item.remessa }}
            </template>
            <template slot="11" slot-scope="row">
                <p v-html="row.item.confirmacao" class="text-left"></p>
            </template>
            <template slot="12" slot-scope="row">
                {{ row.item.dtConfirmacao }}
            </template>
            <template slot="13" slot-scope="row">
                <p v-html="row.item.retorno" class="text-left"></p>
            </template>
            <template slot="14" slot-scope="row">
                {{ row.item.dtRetorno }}
            </template>
            <template slot="15" slot-scope="row">
                {{ row.item.dtPagamento }}
            </template>
        </b-table>

        <ExtratoCda
            ref="extratoCda"
            @closeModal="closeModal" />
    </div>
</template>

<script>
import ExtratoCda from "../../shared/components/ExtratoCda";
export default {
    components: {ExtratoCda},
    props: ['resultado', 'fields', 'configTable'],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false
            this.$emit('consultarDividas')
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage
        },
    },
    methods: {      
        sortingChanged(ctx) {
            if(ctx.sortBy == 1) {
                this.configTable.sortField = 'numeroDivida'
            }
            if(ctx.sortBy == 2) {
                this.configTable.sortField = 'contribuinte'
            }
            if(ctx.sortBy == 3) {
                this.configTable.sortField = 'cpfCnpj'
            }
            if(ctx.sortBy == 4) {
                this.configTable.sortField = 'tipoCredito'
            }
            if(ctx.sortBy == 5) {
                this.configTable.sortField = 'origem'
            }
            if(ctx.sortBy == 6) {
                this.configTable.sortField = 'cadicms'
            }
            if(ctx.sortBy == 7) {
                this.configTable.sortField = 'dataInscricao'
            }
            if(ctx.sortBy == 8) {
                this.configTable.sortField = 'valorTotal'
            }
            if(ctx.sortBy == 9) {
                this.configTable.sortField = 'comarca'
            }
            if(ctx.sortBy == 10) {
                this.configTable.sortField = 'dataEnvioProtesto'
            }
            if(ctx.sortBy == 11) {
                this.configTable.sortField = 'ocorrenciaSolucao'
            }
            if(ctx.sortBy == 12) {
                this.configTable.sortField = 'dataProtocoloT34'
            }
            if(ctx.sortBy == 13) {
                this.configTable.sortField = 'ocorrencia'
            }
            if(ctx.sortBy == 14) {
                this.configTable.sortField = 'dataOcorrencia'
            }
            if(ctx.sortBy == 15) {
                this.configTable.sortField = 'dataPagamentoParcelamento'
            }

            this.configTable.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
            this.$emit('sortingChanged')
        },
        abrirModalExtratoCda(codCdaSefa) {
            this.$refs['extratoCda'].abrirExtrato(codCdaSefa);
        },
        closeModal() {
            this.$refs['extratoCda'].fecharModais();
        },
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}
</style>
